// export const themeOrange = "#df6011";
export const themeOrange = "#F15A24";
export const themeBlue = "#071D5B";
export const themeText = "#071D5B";
export const themeGray = "#FAFAFA";
